import React from 'react';
import { CheckIcon } from 'lucide-react';
const capabilities = ['Load balancing and traffic distribution', 'Database replication and clustering', 'Automatic failover configuration', 'Health monitoring and alerting', 'Disaster recovery planning', 'Performance tuning and optimization'];
export function Capabilities() {
  return <section className="py-16" data-id="element-516">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-517">
        <div className="scroll-fade-in-up" data-id="element-518">
          <div className="bg-surface rounded-xl p-8 md:p-12" data-id="element-519">
            <h2 className="text-2xl font-bold text-ink mb-4" data-id="element-520">
              Key Capabilities
            </h2>
            <p className="text-gray-600 mb-8 leading-relaxed" data-id="element-521">
              We architect and deploy resilient, high-availability
              infrastructure designed to minimize downtime and ensure continuous
              operation for mission-critical systems. Our solutions incorporate
              advanced clustering, load balancing, and automated failover
              mechanisms to handle traffic spikes and hardware failures
              gracefully.
            </p>
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-522">
              {capabilities.map((cap, i) => <li key={i} className="flex items-start" data-id="element-523">
                  <CheckIcon className="w-5 h-5 text-primary mr-3 mt-0.5 flex-shrink-0" data-id="element-524" />
                  <span className="text-gray-700" data-id="element-525">{cap}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}